import { useCallback, useState } from 'react'
import { useClosingReqContext } from '../../../context'
import { setActiveRequirementActionCreator } from '../../../state'

export function useHandlers() {
  const [, dispatch] = useClosingReqContext()

  const [viewDrawerOpen, setViewDrawerOpen] = useState<boolean>(false)
  const [addDrawerOpen, setAddDrawerOpen] = useState<boolean>(false)

  const openAddDrawer = useCallback(() => {
    setAddDrawerOpen(true)
    dispatch(setActiveRequirementActionCreator(undefined))
  }, [dispatch])

  const closeAddDrawer = useCallback(() => {
    setAddDrawerOpen(false)
    dispatch(setActiveRequirementActionCreator(undefined))
  }, [dispatch])

  const openViewDrawer = useCallback(() => {
    setViewDrawerOpen(true)
    dispatch(setActiveRequirementActionCreator('payment'))
  }, [dispatch])

  const closeViewDrawer = useCallback(() => {
    setViewDrawerOpen(false)
    dispatch(setActiveRequirementActionCreator(undefined))
  }, [dispatch])

  return {
    viewDrawerOpen,
    openAddDrawer,
    closeAddDrawer,
    openViewDrawer,
    closeViewDrawer,
    addDrawerOpen,
  }
}
